

export const BoxBtn = ({tag, cname}:{tag: string; cname: string;}) =>{
//'btn-outline-primary'
  const sasabox= 'https://box.sasauchi.jp'
  const konrenjibox= 'https://box.konrenji.or.jp'
  
  function a(){
    let url= ''
    const name= window.location.hostname
    if(name.includes('konrenji')){ 
      url= 'https://box.konrenji.or.jp'
    }
    else if(name.includes('sasauchi')){
      url= 'https://box.sasauchi.jp'
    }
    // debug時
    else if(name.includes('localhost')){
      url= 'https://box.sasauchi.jp'
    }
    //console.log(name, url)
    return url
  }
  
  return(<>
    { a() !== '' &&
      <button type="button" className={cname}
        onClick={()=>window.location.href=a()} >
      {tag}
      </button>
    }
  </>)

}
